import * as React from "react";
import { Field } from "formik";
import { useTranslation } from "react-i18next";
import { Select } from "components/common";
import ControlLabel from "components/bootstrap/ControlLabel";
import Input from "components/bootstrap/Input";
import { DEFAULT_ORIENTATION } from "report/Constants";
const ORIENTATION_OPTIONS = [
  { label: "orientation_select.options.portrait", value: "portrait" },
  { label: "orientation_select.options.landscape", value: "landscape" }
];
const PageSizeSelect = ({ disabled }) => {
  const { t } = useTranslation("enterprise_report");
  return /* @__PURE__ */ React.createElement(Field, { name: "layout.orientation" }, ({ field: { name, value, onChange }, meta: { error } }) => /* @__PURE__ */ React.createElement(Input, { id: name, error }, /* @__PURE__ */ React.createElement(ControlLabel, null, t("orientation_select.label")), /* @__PURE__ */ React.createElement(
    Select,
    {
      disabled,
      onChange: (newValue) => onChange({ target: { name, value: newValue } }),
      value: value != null ? value : DEFAULT_ORIENTATION,
      inputId: name,
      placeholder: t("orientation_select.placeholder"),
      clearable: false,
      options: ORIENTATION_OPTIONS.map((option) => ({ ...option, label: t(option.label) }))
    }
  )));
};
export default PageSizeSelect;
